const hamburgerVisibleRoutesData = [
  '/',
  '/categories',
  '/campaign',
  '/my-singer',
];

export default hamburgerVisibleRoutesData;
